import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import React from "react";
import Login from "../pages/auth/login";
import ResetPassword from "../pages/auth/resetPassword";

import Verification from "../pages/auth/verification";
import Dashboard from "../pages/dashboard/main-dashboard";
import ForgetPassword from "../pages/auth/forgetPassword";
import ChangePassword from "../pages/auth/changePassword";
import Middleware from "../pages/Middleware";

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Middleware />} />
      <Route path="/login*" element={<Login />} />
      <Route path="/forget-password" element={<ForgetPassword />} />
      <Route path="/account-verification*" element={<Verification />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default MainRoutes;
